import { isAfter, isBefore } from "date-fns";
import { useEffect, useState } from "react";
import useFetch from "../../../hooks/useFetch";
import { Renouvellement } from "../../../services/Api/swagger";

export const useRenouvellement = (selectedAdhesion) => {
  const {
    response: responseRenouvellement,
    fetching: fetchingRenouvellement,
    error: errorRenouvellement,
  } = useFetch<Renouvellement>(
    selectedAdhesion,
    "getRenouvellement",
    selectedAdhesion && !selectedAdhesion.mandat ? true : false
  );

  const [isPeriodRenouvellement, setIsPeriodRenouvellement] = useState<boolean>(
    false
  );

  const [isTransactionEnCours, setIsTransactionEnCours] = useState<boolean>(
    false
  );

  const [returnPaiement, setReturnPaiement] = useState<
    "error" | "success" | undefined
  >();
  useEffect(() => {
    if (
      responseRenouvellement &&
      responseRenouvellement.dateDebut &&
      responseRenouvellement.dateFin
    ) {
      setIsPeriodRenouvellement(
        (isAfter(new Date(), new Date(responseRenouvellement.dateDebut)) ||
          new Date().toLocaleDateString() === new Date(responseRenouvellement.dateDebut).toLocaleDateString()) &&
        (isBefore(new Date(), new Date(responseRenouvellement.dateFin)) ||
          new Date().toLocaleDateString() === new Date(responseRenouvellement.dateFin).toLocaleDateString())
      );
    } else {
      setIsPeriodRenouvellement(false);
    }
    if (responseRenouvellement && responseRenouvellement.transactionEnCours) {
      setIsTransactionEnCours(true);
    } else {
      setIsTransactionEnCours(false);
    }
  }, [responseRenouvellement]);
  return {
    responseRenouvellement,
    fetchingRenouvellement,
    errorRenouvellement,
    isTransactionEnCours,
    isPeriodRenouvellement,
    returnPaiement,
    setReturnPaiement,
  };
};
